import { gql } from '@apollo/client'
import { SABRE_PRODUCT_SEARCH_FRAGMENT } from '../fragments/ProductSearchFragment'

export const SABRE_GET_PRODUCTS_SEARCH = gql`
  query GetProductsSearch($input: ProductsInput) {
    products(input: $input) {
      count
      hasMore
      results {
        ...ProductSearch
      }
    }
  }
  ${SABRE_PRODUCT_SEARCH_FRAGMENT}
`
